export const fontSizes = {
  s: '12px',
  m: '14px',
  l: '16px',
  '2l': '20px',
  xl: '28px',
  '2xl': '40px',
};
